export var nth = function (n) {
    return [, 'st', 'nd', 'rd'][(n / 10) % 10 ^ 1 && n % 10] || 'th';
};
//# sourceMappingURL=NumberUtils.js.map